import React from 'react';
import ReactDOM from 'react-dom';

import LoginStatusButton from '../wc-checkout/login/loginStatusButton.jsx';

function initLoginButton() {
  const loginButtonContainer = document.getElementById("login-status-button");
  
  loginButtonContainer && ReactDOM.render(React.createElement(LoginStatusButton, {props: loginStatusButtonProps}), loginButtonContainer);
}

document.addEventListener('DOMContentLoaded', () => {
  initLoginButton();
});